import { co2 } from './common';

export default {
  'consumption.co2': `Keskmine ${co2} heide`,
  'consumption.energy': 'Elektrikulu',
  'consumption.fuel': 'Keskmine kütusekulu',
  'footnotes.local': '',
  'footnotes.wltp': `Nimetatud väärtusi käsitleti vastavalt etteantud mõõtmismeetoditele. Tegu on „WLTP ${co2} väärtustega“ artikkel 2 nr 3 rakendusmääruse (EL) 2017/1153 mõistes. Kütusekulu väärtused arvutati nende väärtuste põhjal. Elektrikulu määrati VO 683/2008/EG alusel. Andmed ei käi konkreetse sõiduki kohta ega ole pakkumise osa, vaid on mõeldud üksnes erinevate sõidukitüüpide võrdlemiseks. Väärtused erinevad olenevalt valitud lisavarustusest`,
  'footnotes.nedc':
    'Kütuse- või energiatarbimine, CO2 heitkogused ja sõiduulatus vastavalt määrusele (EL) 2017/1151. Teistsuguste konfiguratsioonide puhul võivad näitajad erineda. Sõiduauto kütuse- või energiakulu ja CO2 heitkoguse hulka mõjutavad ka sõidustiil ning muud tegurid, mis ei ole tehnilist laadi.',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Otsingusõna',
  'search.result.buy-online': 'Osta veebipoest',
  'search.results': 'Ei leitud ühtegi tulemust | {count} otsingutulemus | {count} otsingutulemust',
  'search.results.count': '{count} otsingutulemust',
  'search.results.backup': 'Ühtegi täpset vastet ei leitud. Vaata sarnaseid tulemusi:',
  'search.results.none.summary': 'Selle otsingusõnaga ei leitud ühtegi tulemust. Palun proovige uuesti. ',
  'search.show-more': 'Näita rohkem',
  'search.unavailable': 'Otsingufunktsioon pole hetkel saadaval.',
  'search.result.new': 'Uus',

  'search.result.consumption': 'uus',

  'input.placeholder': 'Otsingusõna',

  'suggestions.all_search_results': 'Kõik otsingutulemused',
  'suggestions.all_search_results_for': 'Näita kõiki tulemusi',
  'suggestions.in': 'in',

  all: 'Kõik',
  UCOS: 'Kasutatud sõidukite Online Store pood',
  PASSENGER_CARS: 'Sõiduautod',
  VANS: 'Kaubikud',
  NCOS: 'Uute sõidukite Online Store pood',
  VIDEO: 'Videod',
  DEALER_LOCATOR: 'Edasimüüja otsing',
  CONFIGURATOR: 'Mercedes-Benz konfiguraator',
  TEST_DRIVE: 'Proovisõit',
  VEHICLE_SEARCH: 'Kasutatud autode otsing',
  COLLECT: 'Kollektsioon & varustus',
  CONNECT: 'Mercedes me Store pood',

  'watch.video': 'Vaata videot',
  'input.recently': 'Hiljuti otsitud',
  'input.help.title': 'Mida otsida?',
  'input.help.text':
    'Otsige sõidukitüüpide, mudelite, seadistuskoodide või lisaseadmete, muude toodete ja teabe alusel',

  'search.result.grid': 'Ruudustik',
  'search.result.list': 'Loend',

  // Empty result
  'support.check': 'Palun kontrollige õigekirja või proovige mõne teise sõnaga uuesti.',
  'support.no.results': 'Sellele otsingusõnale puuduvad vasted.',
  'support.no.results.term': 'Tulemusi ei leitud.',
  'support.chat': 'Kas te ei leia otsitavat? Palun kasutage meie omasid. ',
  'support.chat.with.us': 'Vestlustugi veebis.',
};
